var render = function render(_c, _vm) {
  return _c(
    "svg",
    {
      attrs: {
        width: "16px",
        height: "16px",
        viewBox: "0 0 16 16",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
      },
    },
    [
      _c("title", [_vm._v("Icon / Edit")]),
      _vm._v(" "),
      _c("desc", [_vm._v("Created with Sketch.")]),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "Icon-/-Edit",
            stroke: "none",
            "stroke-width": "1",
            fill: "none",
            "fill-rule": "evenodd",
          },
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Icons",
                transform: "translate(-38.000000, -190.000000)",
              },
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "Edit",
                    transform: "translate(38.000000, 190.000000)",
                  },
                },
                [
                  _c("rect", {
                    attrs: {
                      id: "Rectangle",
                      x: "0",
                      y: "0",
                      width: "16",
                      height: "16",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      id: "Combined-Shape",
                      d: "M9.01070524,0.434709667 C9.40810554,0.434709667 9.73026213,0.75686626 9.73026213,1.15426656 C9.73026213,1.55166685 9.40810554,1.87382345 9.01070524,1.87382345 L9.01070524,1.87382345 L4.31919432,1.87382345 C3.12699344,1.87382345 2.16052366,2.84029322 2.16052366,4.03249411 L2.16052366,4.03249411 L2.16052366,11.9476199 C2.16052366,13.1398208 3.12699344,14.1062906 4.31919432,14.1062906 L4.31919432,14.1062906 L11.5147632,14.1062906 C12.7069641,14.1062906 13.6734339,13.1398208 13.6734339,11.9476199 L13.6734339,11.9476199 L13.6734339,7.97566586 C13.6734339,7.57826557 13.9955905,7.25610898 14.3929908,7.25610898 C14.7903911,7.25610898 15.1125477,7.57826557 15.1125477,7.97566586 L15.1125477,7.97566586 L15.1125477,11.9476199 C15.1101687,13.9336352 13.5007785,15.5430254 11.5147632,15.5454043 L11.5147632,15.5454043 L4.31919432,15.5454043 C2.33317907,15.5430254 0.723788819,13.9336352 0.72140988,11.9476199 L0.72140988,11.9476199 L0.72140988,4.03249411 C0.723788819,2.04647885 2.33317907,0.437088606 4.31919432,0.434709667 L4.31919432,0.434709667 Z M11.3993246,1.71970088 C12.2468881,0.857982912 13.6287119,0.834611009 14.5049321,1.66717322 C15.3350857,2.54405447 15.3117442,3.92376234 14.4524045,4.7720612 L14.4524045,4.7720612 L8.56570958,10.6594757 C8.46927635,10.7557001 8.34750857,10.8225725 8.21456582,10.8523169 L8.21456582,10.8523169 L5.5910614,11.4401949 C5.35135694,11.4898894 5.10274034,11.4155666 4.92963953,11.2424658 C4.75653873,11.069365 4.68221593,10.8207484 4.73191047,10.581044 L4.73191047,10.581044 L5.31978845,7.95753955 C5.34948121,7.82400191 5.416625,7.70169539 5.51334925,7.60495667 L5.51334925,7.60495667 Z M12.9816302,2.48890719 C12.7685676,2.49562942 12.5663864,2.58459949 12.4174976,2.73715432 L12.4174976,2.73715432 L6.67831186,8.47634007 L6.38257398,9.7859336 L7.69360663,9.49163484 L13.4327924,3.75244909 C13.5847704,3.60322833 13.6734184,3.40119327 13.6803199,3.18831649 C13.6871331,3.00078467 13.616634,2.81868356 13.48532,2.68462667 C13.3496023,2.55583292 13.1687018,2.48554015 12.9816302,2.48890719 Z",
                      fill: "#2F477C",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }